import {
    Divider,
    Flex,
    Image,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Text,
    useDisclosure,
    useTheme,
} from '@chakra-ui/react';
import React from 'react';
import CanopyIconButton from '../../../canopy-ui-components/components/IconButton/IconButton';
import * as ga from '../../../canopy-ui-components/google-analytics';
import { useCurrentColors } from '../../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
import CreateForm, {
    AnalyticsMapping,
} from '../CreateAnalyticsMappings/CreateForm';

interface Props extends PageComponentProps<any> {
    mapping?: AnalyticsMapping[];
    showModal: boolean;
    setShowModal: (flag: boolean) => void;
    refreshData: () => void;
    globalProps: GlobalProps;
}

export const CopyAndCreateModal = ({
    mapping = [],
    showModal,
    setShowModal,
    globalProps,
    refreshData,
    ...props
}: any): any => {
    const currentColors = useCurrentColors();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { t } = globalProps;
    const theme = useTheme();
    const logo = theme?.images?.headerLogo;

    const handleOnClose = React.useCallback(() => {
        ga.event({
            action: `${window.location.pathname.replace(
                '//g/',
                ''
            )} > Close Copy Mapping Modal`,
        });

        if (refreshData) {
            refreshData();
        }

        setShowModal(false);
    }, []);

    React.useEffect(() => {
        showModal ? onOpen() : onClose();
    }, [showModal]);

    return (
        <Modal
            isCentered
            closeOnOverlayClick={false}
            isOpen={isOpen}
            size="6xl"
            scrollBehavior={'inside'}
            onClose={handleOnClose}>
            <ModalOverlay
                style={{
                    backdropFilter: 'blur(5px)',
                }}
            />
            <ModalContent>
                <ModalHeader
                    color={currentColors.brand['10']}
                    fontSize="20px"
                    fontWeight="bold"
                    padding="15px">
                    <Flex alignItems="center">
                        <Image
                            src={logo}
                            maxWidth="100%"
                            width="auto"
                            height={'35px'}
                            mr="17.5px"
                        />
                        <Text width="100%">{t('create-mappings')}</Text>
                    </Flex>
                    <Divider
                        borderColor={currentColors.brand['700']}
                        width="100%"
                        mb="0px"
                    />
                </ModalHeader>
                <ModalCloseButton
                    as={() => (
                        <CanopyIconButton
                            background="transparent"
                            cursor="pointer"
                            border="none"
                            display="inline-flex"
                            onClick={handleOnClose}
                            color={currentColors.brand['500']}
                            width="24px"
                            height="24px"
                            aria-label="remove"
                            icon="ActClose"
                            variant="ghost"
                            position="absolute"
                            top="15px"
                            right="15px"
                        />
                    )}
                />
                <ModalBody>
                    <CreateForm
                        globalProps={globalProps}
                        initialMapping={mapping}
                        refreshData={refreshData}
                        onSave={handleOnClose}
                        {...props}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default CopyAndCreateModal;
